import React from 'react';
import ConsentBanner from '../components/ConsentBanner';

const LayoutLanding = ({ children }) => (
  <React.Fragment>
    <a className="skip-link" href="#main-content">
      Skip to main content
    </a>
    <main className="site-content" id="main-content" role="main" tabIndex={-1}>
      {children}
    </main>
    <ConsentBanner />
  </React.Fragment>
);

export default LayoutLanding;
